import React from 'react'

import ControlShowInProjectsTree from "../../../../core/gd-app/component/quick-links/aim"
import ProjectHeaderLocalSettings from "./local-settings"
import ProjectSession from "../../../../core/model2/project/project-session"
import {SESSION_PROJECT_CHANGE, SESSION_PROJECT_SETTINGS_CHANGE} from "../../../../core/gd/bus/bus-event-type"
import {ProjectSystemType} from "../../../../core/model2/project/types"
import ProjectView from "../../../../core/model2/project-view/project-view"
import CompaniesCollection from "../../../../core/gd-model/tree/companies-collection"
import ErrorBoundary from "../../../../core/error-boundary"
import CustomersQuickLink from "../../../../core/gd-app/component/quick-links/customers"
import UsersQuickLink from "../../../../core/gd-app/component/quick-links/users"
import Submenu from './submenu/submenu'
import ProjectTitle from './project-title/project-title'
import CompactTopProject from "./compact-top/compact-top"
import Pin from "../../../../core/gd-components/pin/v2/pin"

type Props = {
    // curMenuId?      : any
}

const debug = false
// const debug = "TopProject"

export default class TopProject extends React.Component<Props> {

    public uid      : any   // ???
    public project  : ProjectSession

    constructor(props:Props) {
        super(props);

        this.uid = gd.utils.guid()

        this.project = gd.session.projects.get(gd.projectViews.project.id)!
        gd.bus.subscribe(SESSION_PROJECT_CHANGE, this, this.onProjectChanged)
        gd.session.projectUsers.on('change add remove reset', this.update, this);

        gd.bus.subscribe(SESSION_PROJECT_SETTINGS_CHANGE, this, this.update);
        gd.bus.subscribe('toggle-submenu', this, this.onToggleSubmenu)
    }

    componentWillUnmount() {
        gd.session.projectUsers.off(null, this.update, this);
        gd.bus.unsubscribe(this);
    }

    UNSAFE_componentWillReceiveProps(newProps:any) {
        this.project = gd.session.projects.get(gd.projectViews.project.id)!
    }

    onProjectChanged = (projectId:ID) => {
        if (gd.projectViews.project.id === projectId) {
            // setTimeout is required because SESSION_PROJECT_CHANGE is fired for all subscribers
            // and if one of subscribed components is unmounted (and unsubscribed) it will still get its subscribed events
            // which causes error calling update on unmounted component
            // Therefore we let all child components to process SESSION_PROJECT_CHANGE before it is processed here
            setTimeout(()=>{
                this.onToggleSubmenu() // forceUpdate is called subsequently
                // this.forceUpdate()
            }, 0)
        }
    }
    update = () => {this.forceUpdate()};

    onToggleSubmenu = () => {
        gd.layout.applyTopPanelSettings({projectId: this.project?.id})
        this.forceUpdate()
    }

    onChangeView = (viewId:ID) => {
        const projectView : ProjectView | null = gd.projectViews.get(viewId)

        if (!projectView) return

        gd.goTo(projectView.url)
    }

    render() {

        const localSettings = new ProjectHeaderLocalSettings()

        // let parents = false;
        let parentTreeSource = new CompaniesCollection([gd.session.companies.get(gd.companyId)]);
        parentTreeSource.resetCompanyProjects(gd.companyId, {
            silent: true,
            includeArchived: true
        });

        if (!this.project) {
            console.error("#DKDJDJHIWU  - no project passes ?")
            return null
        }

        const treeProject = parentTreeSource.getProject(this.project.id);

        // treeProject may be empty after project delete until topApp is updated
        if (!treeProject && !this.project.isTemplate) return false;

        const isSubmenuCompact  = localSettings.isSubmenuCompact(gd.projectViews.project.id) || this.project.isLink
        const isMenuMinimized   = this.project.hasMenu && isSubmenuCompact
        const hideSubmenu       = !this.project.hasMenu || isSubmenuCompact
        const noBottomBorder    = hideSubmenu && [ProjectSystemType.PAGE/*, ProjectSystemType.EMBED*/].includes(this.project.systemType) && !gd.getApp()?.isSubpagesListVisible

        // const isSubmenuCompact  = localSettings.isSubmenuCompact(gd.projectViews.project.id) || this.project.isLink
        // const noBottomBorder    = hideSubmenu && [ProjectSystemType.PAGE/*, ProjectSystemType.EMBED*/].includes(this.project.systemType) && !gd.getApp()?.isSubpagesListVisible

        const classes = Classes("ui5-app-header project-header", {
            'with-menu'     : !hideSubmenu,
            'no-underline'  : noBottomBorder
        })

        const quickControlsClasses = Classes("quick-controls", {
            'is-hidden': hideSubmenu
        })

        return (
            <div className={classes}>
                <div className="left">
                    <ErrorBoundary>
                        <ProjectTitle projectId = {this.project.id}/>

                        {!isMenuMinimized &&
                            <ControlShowInProjectsTree project={this.project}/>
                        }

                        {isMenuMinimized &&
                            <CompactTopProject project={this.project}/>
                        }

                    </ErrorBoundary>
                </div>
                <div className={quickControlsClasses}>
                    <CustomersQuickLink project={this.project}/>
                    <UsersQuickLink project={this.project}/>

                    {this.project.properties.availableMenuOptions.pinStar &&
                        <Pin data={{projectId: this.project.id}}/>
                    }

                </div>

                {!hideSubmenu &&
                    <Submenu project={this.project} />
                }
            </div>
        )
    }
}